import {
  AsyncInteractor,
  IBlocAsyncInteractor
} from "@kernel/frontend-react-app";
import { MediaDeviceService } from "../services";
import { Device, DeviceList } from "@domain";
import { UniqueEntityId } from "@kernel/ddd";

export interface EnumerateMediaDeviceService {
  enumerate(): Promise<MediaDeviceInfo[]>;
}

export class EnumerateMediaDeviceInteractor
  extends AsyncInteractor<EnumerateMediaDeviceService, void, DeviceList>
  implements IBlocAsyncInteractor<DeviceList, void>
{
  public async execute(): Promise<DeviceList> {
    const handledDevices = await this.service.enumerate();
    const devices = handledDevices.map((device) => this.buildDevice(device));
    return DeviceList.create(devices);
  }

  private buildDevice(deviceInfo: MediaDeviceInfo) {
    const id = new UniqueEntityId(deviceInfo.deviceId);
    return Device.create({ info: deviceInfo }, id);
  }

  public static create() {
    const service = new MediaDeviceService();
    return new EnumerateMediaDeviceInteractor(service);
  }
}
